import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import { ref, push, set } from "firebase/database";

// التحقق من Electron
const isElectron = () => window.electronAPI !== undefined;

const CategoryForm = ({ uid, editCategoryData, onFinish, onCategoryChange }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editCategoryData) {
      setName(editCategoryData.name || "");
    } else {
      setName("");
    }
  }, [editCategoryData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      alert("⚠️ الرجاء إدخال اسم التصنيف");
      return;
    }

    if (!uid) {
      alert("Erreur: Utilisateur non identifié");
      return;
    }

    setLoading(true);

    try {
      if (isElectron()) {
        // ✅ وضع Electron (SQLite)
        if (editCategoryData) {
          // تعديل
          await window.electronAPI.updateCategory({ 
            id: editCategoryData.id, 
            name: name.trim(),
          });
          alert(`✅ تم التعديل بنجاح (محلياً)`);
        } else {
          // إضافة جديدة
          const result = await window.electronAPI.addCategory({ 
            name: name.trim(),
          });
          if (result.success) {
            alert(`✅ تمت الإضافة بنجاح!\n📌 تم حفظ التصنيف في قاعدة البيانات المحلية.\n🔄 سيتم المزامنة مع السحابة عند عودة الإنترنت.`);
          }
        }
      } else {
        // ✅ وضع المتصفح (Firebase)
        if (editCategoryData) {
          // تعديل
          await set(ref(db, `distributors/${uid}/categories/${editCategoryData.id}`), {
            id: editCategoryData.id,
            name: name.trim(),
            updatedAt: Date.now(),
          });
          alert("✅ تم التعديل بنجاح");
        } else {
          // إضافة
          const newRef = push(ref(db, `distributors/${uid}/categories`));
          await set(newRef, {
            id: newRef.key,
            name: name.trim(),
            createdAt: Date.now(),
          });
          alert("✅ تمت الإضافة بنجاح");
        }
      }

      // مسح الحقل
      setName("");
      
      // تحديث القائمة
      if (onFinish) onFinish();
      if (onCategoryChange) onCategoryChange();
      
    } catch (error) {
      console.error("Erreur:", error);
      alert("Une erreur est survenue: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        gap: "10px",
        marginBottom: "20px",
        flexWrap: "wrap",
      }}
    >
      <input
        type="text"
        placeholder="Nom de catégorie *"
        value={name}
        onChange={(e) => setName(e.target.value)}
        disabled={loading}
        style={{
          padding: "8px 12px",
          border: "1px solid #d1d5db",
          borderRadius: "6px",
          flex: 2,
          minWidth: "200px",
        }}
        required
      />
      <button
        type="submit"
        disabled={loading}
        style={{
          padding: "8px 16px",
          background: loading ? "#9ca3af" : "#3b82f6",
          color: "white",
          border: "none",
          borderRadius: "6px",
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "Chargement..." : (editCategoryData ? "Modifier" : "Ajouter")}
      </button>
      {editCategoryData && (
        <button
          type="button"
          onClick={() => {
            setName("");
            if (onFinish) onFinish();
          }}
          style={{
            padding: "8px 16px",
            background: "#6b7280",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Annuler
        </button>
      )}
    </form>
  );
};

export default CategoryForm;